// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-63f4d09f]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.insuredPrice-component .text[data-v-63f4d09f] {\n  line-height: 16px;\n  padding: 0 10px 0 13px;\n  font-size: 12px;\n}\n.insuredPrice-component p[data-v-63f4d09f] {\n  margin-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
